/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} NotesInputs */

const fr_notes = /** @type {(inputs: NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes`)
};

/**

* @param {NotesInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const notes = /** @type {((inputs?: NotesInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<NotesInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_notes(inputs)
});